/** Matches /notes/p/... with optional two-letter locale prefix (see getRouteLocale). */
export const isNotesPatientQuestionnairePath = (pathname = "") => /^\/(?:[a-z]{2}\/)?notes\/p(?:\/|$)/i.test(pathname);

/** Public patient-intake URLs only; excludes staff dashboard under /user/patient-intake. */
export const isPublicPatientFacingIntakePath = (pathname = "") =>
	pathname.includes("/patient-intake") && !pathname.includes("/user/patient-intake");

/**
 * Logged-in staff opening public patient intake in a top-level tab (not iframe).
 * Patient questionnaire URLs (/notes/p/…) are excluded; the router redirects logged-in users.
 */
export const shouldShowPatientFacingStaffFlash = (pathname, isInIframe) =>
	isPublicPatientFacingIntakePath(pathname) && !isNotesPatientQuestionnairePath(pathname) && !isInIframe;
